
export default function (testedValue,referenceValue,options) {
	if (testedValue == referenceValue)
		return options.fn(this)

	return options.inverse(this)
}
